// D&P: Subcold pre-order guard.
// Collective forces "continue selling when out of stock" on for Subcold variants, so the theme's
// own JS re-enables Add to cart when switching variants. This keeps the button disabled and blocks
// the add-to-cart submit whenever the form's CURRENT variant id is one the Liquid templates have
// marked as a 0-stock Subcold variant (elements with data-dp-preorder-variant="<variant id>").
(() => {
  if (window.__dpPreorderGuard) return;
  window.__dpPreorderGuard = true;

  /** @param {Element | null} form */
  const isBlocked = (form) => {
    if (!(form instanceof HTMLFormElement)) return false;
    const idInput = form.querySelector('input[name="id"]');
    const id = idInput instanceof HTMLInputElement ? idInput.value : '';
    if (!id) return false;
    return !!document.querySelector('[data-dp-preorder-variant="' + CSS.escape(id) + '"]');
  };

  const sync = () => {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      const blocked = isBlocked(form);
      if (form.classList.contains('dp-blocked') !== blocked) form.classList.toggle('dp-blocked', blocked);
      form.querySelectorAll('button[type="submit"][name="add"]').forEach((btn) => {
        if (!(btn instanceof HTMLButtonElement)) return;
        if (blocked) {
          if (!btn.disabled) btn.disabled = true;
          if (btn.dataset.dpBlocked !== 'true') btn.dataset.dpBlocked = 'true';
        } else if (btn.dataset.dpBlocked) {
          delete btn.dataset.dpBlocked;
        }
      });
    });
  };

  // Block the submit itself (runs before the theme's own handlers).
  document.addEventListener(
    'submit',
    (event) => {
      if (isBlocked(/** @type {Element} */ (event.target))) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const target = /** @type {Element} */ (event.target);
      const btn = target && target.closest ? target.closest('button[type="submit"][name="add"]') : null;
      if (btn && isBlocked(btn.closest('form'))) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      sync();
    });
  };

  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled', 'value'],
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
